import PropTypes from 'prop-types';
import React from 'react';
const SpreadsheetContext = /*#__PURE__*/React.createContext();
const {
  Provider
} = SpreadsheetContext;
const reducer = (state, action) => {
  switch (action.type) {
    case 'maximizeSize':
      return {
        ...state,
        maximize: true
      };
    case 'restoreSize':
      return {
        ...state,
        maximize: false
      };
    default:
      throw new Error();
  }
};
const SpreadsheetManager = /*#__PURE__*/React.memo(props => {
  const [state, dispatch] = React.useReducer(reducer, {
    maximize: false
  });
  const onMaximizeSize = React.useCallback(() => dispatch({
    type: 'maximizeSize'
  }), []);
  const onRestoreSize = React.useCallback(() => dispatch({
    type: 'restoreSize'
  }), []);
  const providerValue = React.useMemo(() => ({
    ...state,
    rows: props.rows,
    headerCells: props.headerCells,
    onMaximizeSize,
    onRestoreSize
  }), [onMaximizeSize, onRestoreSize, props.headerCells, props.rows, state]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: providerValue
  }, typeof props.children === 'function' ? props.children(providerValue) : props.children);
});
SpreadsheetManager.propTypes = {
  headerCells: PropTypes.arrayOf(PropTypes.object).isRequired,
  headerCellsLastUpdated: PropTypes.string,
  rows: PropTypes.arrayOf(PropTypes.object),
  rowsLastUpdated: PropTypes.string
};
SpreadsheetManager.defaultProps = {};
export default SpreadsheetManager;
export { SpreadsheetContext };